import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Organization } from '@core/objects/organization';
import { UrlService } from '@core/services/url/url.service';


// * 1. import
import { CoreResponseUtilsService } from '@core/services/utils/response-utils.service';
//  * 2. add service to constructor

//  * 3. use the proper method in the service to return a correct response.
// return this.responseUtilsSrv.simulate500InternalServerError()
//  * 4. how to use to simulate get response

@Injectable({
  providedIn: 'root'
})
export class OrganizationRequests {
    private readonly organizations_ep = "/settings/organizations";
    private readonly logos_ep = "/settings/organizations/logos";

    constructor(private http: HttpClient, private urlSrv: UrlService,private responseUtilsSrv:CoreResponseUtilsService) {}


    /**
     * Updates the organization with the given name.
     *
     * @param name - The new name of the organization.
     * @returns An Observable that emits the updated Organization object.
     */
    public updateOrganization$ = (name: string): Observable<Organization> => {
        let payload = { name: name };
        return this.http.put<Organization>(this.urlSrv.build(this.organizations_ep), payload);
    }

    /**
     * Save a new version of the logo
     * @param {any} fileId - The identifier of the file
     * @param {any} fileOptions - The options of the file crop and resize
     * @returns {Observable<any>} - To wait for the response
     * @memberof OrganizationRequests
     */
    public uploadLogo$ = (fileId: string, options: object): Observable<any> => {
        let payload = { file_id: fileId, options: options };
        return this.http.post<any>(this.urlSrv.build(this.logos_ep), payload);
    }

    /**
     * Delete the logo for current organization
     * @returns {Observable<any>} to wait for the response
     * @memberof OrganizationRequests
     */
    public deleteLogo$ = (): Observable<any> => {
        return this.http.delete<any>(this.urlSrv.build(this.logos_ep));
    }
}
